/**
 * Generated by orval 🍺
 * Do not edit manually.
 * qcs control-plane
 * OpenAPI spec version: 0.1.0
 */

export type SettingSource = typeof SettingSource[keyof typeof SettingSource];


export const SettingSource = {
  code: 'code',
  env: 'env',
  db: 'db',
} as const;
